// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Enhanced Invoice Dashboard Styles
 * Modern, responsive styles for enhanced invoice dashboard
 */

.enhanced-invoice-dashboard {
  padding: 24px;
  background:
    radial-gradient(circle at 20% 80%, rgba(102, 126, 234, 0.05) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(118, 75, 162, 0.05) 0%, transparent 50%),
    linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
}

/* Header */
.enhanced-invoice-dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  padding: 24px;
  background: linear-gradient(135deg, #EA580C, #FDBA74);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.1),
    0 4px 16px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.header-content h2 {
  color: #2d3748;
  font-size: 2rem;
  font-weight: 700;
  margin: 0 0 8px 0;
  line-height: 1.2;
}

.header-content p {
  color: #4a5568;
  font-size: 1rem;
  margin: 0;
  line-height: 1.5;
}

.header-actions {
  display: flex;
  gap: 12px;
}

/* Tabs */
.dashboard-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 24px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 12px;
  padding: 8px;
  box-shadow:
    0 4px 16px rgba(0, 0, 0, 0.1),
    0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.tab-button {
  flex: 1 1;
  padding: 12px 16px;
  border: none;
  background: transparent;
  color: #4a5568;
  font-size: 0.9rem;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.tab-button:hover {
  background: rgba(13, 59, 102, 0.1);
  color: #0D3B66;
}

.tab-button.active {
  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

/* Tab Content */
.tab-content {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 12px;
  padding: 24px;
  box-shadow:
    0 4px 16px rgba(0, 0, 0, 0.1),
    0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

/* Statistics Section */
.statistics-section {
  margin-bottom: 32px;
}

.statistics-section h3 {
  color: #2d3748;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 16px 0;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}

.stat-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow:
    0 4px 16px rgba(0, 0, 0, 0.1),
    0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow:
    0 8px 24px rgba(0, 0, 0, 0.15),
    0 4px 12px rgba(0, 0, 0, 0.08);
}

.stat-card.draft .stat-icon {
  background: linear-gradient(135deg, #d69e2e 0%, #b7791f 100%);
}

.stat-card.sent .stat-icon {
  background: linear-gradient(135deg, #3182ce 0%, #2c5aa0 100%);
}

.stat-card.paid .stat-icon {
  background: linear-gradient(135deg, #38a169 0%, #2f855a 100%);
}

.stat-card.overdue .stat-icon {
  background: linear-gradient(135deg, #e53e3e 0%, #c53030 100%);
}

.stat-card.amount .stat-icon {
  background: linear-gradient(135deg, #9f7aea 0%, #805ad5 100%);
}

.stat-icon {
  font-size: 2rem;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: white;
  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);
}

.stat-content h4 {
  color: #4a5568;
  font-size: 0.9rem;
  font-weight: 600;
  margin: 0 0 4px 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.stat-value {
  color: #2d3748;
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  line-height: 1.2;
}

/* Sync Section */
.sync-section {
  margin-bottom: 32px;
}

.sync-section h3 {
  color: #2d3748;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 16px 0;
}

.sync-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}

.sync-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow:
    0 4px 16px rgba(0, 0, 0, 0.1),
    0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.sync-card:hover {
  transform: translateY(-2px);
  box-shadow:
    0 8px 24px rgba(0, 0, 0, 0.15),
    0 4px 12px rgba(0, 0, 0, 0.08);
}

.sync-card.failed .sync-icon {
  background: linear-gradient(135deg, #e53e3e 0%, #c53030 100%);
}

.sync-card.pending .sync-icon {
  background: linear-gradient(135deg, #d69e2e 0%, #b7791f 100%);
}

.sync-card.success-rate .sync-icon {
  background: linear-gradient(135deg, #38a169 0%, #2f855a 100%);
}

.sync-icon {
  font-size: 2rem;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: white;
  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);
}

.sync-content h4 {
  color: #4a5568;
  font-size: 0.9rem;
  font-weight: 600;
  margin: 0 0 4px 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.sync-value {
  color: #2d3748;
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  line-height: 1.2;
}

/* System Status Section */
.system-status-section {
  margin-bottom: 32px;
}

.system-status-section h3 {
  color: #2d3748;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 16px 0;
}

.status-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}

.status-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow:
    0 4px 16px rgba(0, 0, 0, 0.1),
    0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.status-card:hover {
  transform: translateY(-2px);
  box-shadow:
    0 8px 24px rgba(0, 0, 0, 0.15),
    0 4px 12px rgba(0, 0, 0, 0.08);
}

.status-card.configured .status-icon,
.status-card.connected .status-icon,
.status-card.running .status-icon {
  background: linear-gradient(135deg, #38a169 0%, #2f855a 100%);
}

.status-card.not-configured .status-icon,
.status-card.disconnected .status-icon,
.status-card.stopped .status-icon {
  background: linear-gradient(135deg, #e53e3e 0%, #c53030 100%);
}

.status-icon {
  font-size: 2rem;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: white;
  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);
}

.status-content h4 {
  color: #4a5568;
  font-size: 0.9rem;
  font-weight: 600;
  margin: 0 0 4px 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-content p {
  color: #2d3748;
  font-size: 1.2rem;
  font-weight: 700;
  margin: 0;
  line-height: 1.2;
}

/* Recent Invoices Section */
.recent-invoices-section {
  margin-bottom: 32px;
}

.recent-invoices-section h3 {
  color: #2d3748;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 16px 0;
}

.invoices-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.invoice-item {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 8px;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow:
    0 2px 8px rgba(0, 0, 0, 0.1),
    0 1px 4px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.invoice-info {
  display: flex;
  gap: 12px;
  align-items: center;
}

.invoice-number {
  background: rgba(13, 59, 102, 0.1);
  color: #0D3B66;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.invoice-member {
  color: #2d3748;
  font-weight: 500;
}

.invoice-details {
  display: flex;
  gap: 12px;
  align-items: center;
}

.invoice-amount {
  color: #2d3748;
  font-weight: 600;
  font-size: 1.1rem;
}

.invoice-status {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.invoice-status.draft {
  background: rgba(214, 158, 46, 0.1);
  color: #d69e2e;
}

.invoice-status.sent {
  background: rgba(49, 130, 206, 0.1);
  color: #3182ce;
}

.invoice-status.paid {
  background: rgba(56, 161, 105, 0.1);
  color: #38a169;
}

.invoice-status.overdue {
  background: rgba(229, 62, 62, 0.1);
  color: #e53e3e;
}

/* Overdue Invoices Section */
.overdue-invoices-section h3 {
  color: #2d3748;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 16px 0;
}

.overdue-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.overdue-item {
  background: rgba(229, 62, 62, 0.05);
  border: 1px solid rgba(229, 62, 62, 0.2);
  border-radius: 8px;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.overdue-info {
  display: flex;
  gap: 12px;
  align-items: center;
}

.overdue-number {
  background: rgba(229, 62, 62, 0.1);
  color: #e53e3e;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.overdue-member {
  color: #2d3748;
  font-weight: 500;
}

.overdue-days {
  color: #e53e3e;
  font-weight: 600;
  font-size: 0.9rem;
}

.overdue-amount {
  color: #2d3748;
  font-weight: 600;
  font-size: 1.1rem;
}

/* Empty States */
.no-invoices {
  text-align: center;
  padding: 40px;
  color: #4a5568;
}

/* Loading and Error States */
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

.error-state {
  text-align: center;
  padding: 60px 20px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.1),
    0 4px 16px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.error-state h3 {
  color: #2d3748;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 12px 0;
}

.error-state p {
  color: #4a5568;
  font-size: 1rem;
  margin: 0 0 24px 0;
  line-height: 1.5;
}

/* Buttons */
.btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-primary {
  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);
  color: white;
}

.btn-primary:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.btn-outline {
  background: transparent;
  color: #0D3B66;
  border: 1px solid #0D3B66;
}

.btn-outline:hover:not(:disabled) {
  background: #0D3B66;
  color: white;
}

.btn-sm {
  padding: 6px 12px;
  font-size: 0.8rem;
}

/* Responsive Design */
@media (max-width: 768px) {
  .enhanced-invoice-dashboard {
    padding: 16px;
  }

  .enhanced-invoice-dashboard-header {
    flex-direction: column;
    gap: 16px;
    text-align: center;
  }

  .header-actions {
    width: 100%;
    justify-content: center;
  }

  .dashboard-tabs {
    flex-direction: column;
  }

  .tab-button {
    text-align: center;
  }

  .stats-grid,
  .sync-cards,
  .status-cards {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }

  .invoice-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .invoice-details {
    flex-direction: column;
    align-items: flex-start;
  }
}

@media (max-width: 480px) {
  .enhanced-invoice-dashboard {
    padding: 12px;
  }

  .enhanced-invoice-dashboard-header {
    padding: 16px;
  }

  .header-content h2 {
    font-size: 1.5rem;
  }

  .stats-grid,
  .sync-cards,
  .status-cards {
    grid-template-columns: 1fr;
  }

  .stat-card,
  .sync-card,
  .status-card {
    padding: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/invoices/EnhancedInvoiceDashboard.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,aAAa;EACb;;;qDAGmD;EACnD,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,qDAAqD;EACrD,2BAA2B;EAC3B,mBAAmB;EACnB;;kCAEgC;EAChC,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,SAAS;AACT;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ;;iCAE+B;EAC/B,0CAA0C;AAC5C;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,+CAA+C;AACjD;;AAEA,gBAAgB;AAChB;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb;;iCAE+B;EAC/B,0CAA0C;AAC5C;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT;;iCAE+B;EAC/B,0CAA0C;EAC1C,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B;;kCAEgC;AAClC;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,6DAA6D;AAC/D;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT;;iCAE+B;EAC/B,0CAA0C;EAC1C,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B;;kCAEgC;AAClC;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,6DAA6D;AAC/D;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT;;iCAE+B;EAC/B,0CAA0C;EAC1C,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B;;kCAEgC;AAClC;;AAEA;;;EAGE,6DAA6D;AAC/D;;AAEA;;;EAGE,6DAA6D;AAC/D;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,6DAA6D;AAC/D;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB;;iCAE+B;EAC/B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mCAAmC;EACnC,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB;;kCAEgC;EAChC,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;;IAGE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;;IAGE,0BAA0B;EAC5B;;EAEA;;;IAGE,aAAa;EACf;AACF","sourcesContent":["/**\n * Enhanced Invoice Dashboard Styles\n * Modern, responsive styles for enhanced invoice dashboard\n */\n\n.enhanced-invoice-dashboard {\n  padding: 24px;\n  background:\n    radial-gradient(circle at 20% 80%, rgba(102, 126, 234, 0.05) 0%, transparent 50%),\n    radial-gradient(circle at 80% 20%, rgba(118, 75, 162, 0.05) 0%, transparent 50%),\n    linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n  min-height: 100vh;\n}\n\n/* Header */\n.enhanced-invoice-dashboard-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 32px;\n  padding: 24px;\n  background: linear-gradient(135deg, #EA580C, #FDBA74);\n  backdrop-filter: blur(20px);\n  border-radius: 16px;\n  box-shadow:\n    0 8px 32px rgba(0, 0, 0, 0.1),\n    0 4px 16px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.header-content h2 {\n  color: #2d3748;\n  font-size: 2rem;\n  font-weight: 700;\n  margin: 0 0 8px 0;\n  line-height: 1.2;\n}\n\n.header-content p {\n  color: #4a5568;\n  font-size: 1rem;\n  margin: 0;\n  line-height: 1.5;\n}\n\n.header-actions {\n  display: flex;\n  gap: 12px;\n}\n\n/* Tabs */\n.dashboard-tabs {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 24px;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 12px;\n  padding: 8px;\n  box-shadow:\n    0 4px 16px rgba(0, 0, 0, 0.1),\n    0 2px 8px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.tab-button {\n  flex: 1;\n  padding: 12px 16px;\n  border: none;\n  background: transparent;\n  color: #4a5568;\n  font-size: 0.9rem;\n  font-weight: 600;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.tab-button:hover {\n  background: rgba(13, 59, 102, 0.1);\n  color: #0D3B66;\n}\n\n.tab-button.active {\n  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);\n  color: white;\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n}\n\n/* Tab Content */\n.tab-content {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 12px;\n  padding: 24px;\n  box-shadow:\n    0 4px 16px rgba(0, 0, 0, 0.1),\n    0 2px 8px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n/* Statistics Section */\n.statistics-section {\n  margin-bottom: 32px;\n}\n\n.statistics-section h3 {\n  color: #2d3748;\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 0 0 16px 0;\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n}\n\n.stat-card {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 12px;\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  box-shadow:\n    0 4px 16px rgba(0, 0, 0, 0.1),\n    0 2px 8px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.stat-card:hover {\n  transform: translateY(-2px);\n  box-shadow:\n    0 8px 24px rgba(0, 0, 0, 0.15),\n    0 4px 12px rgba(0, 0, 0, 0.08);\n}\n\n.stat-card.draft .stat-icon {\n  background: linear-gradient(135deg, #d69e2e 0%, #b7791f 100%);\n}\n\n.stat-card.sent .stat-icon {\n  background: linear-gradient(135deg, #3182ce 0%, #2c5aa0 100%);\n}\n\n.stat-card.paid .stat-icon {\n  background: linear-gradient(135deg, #38a169 0%, #2f855a 100%);\n}\n\n.stat-card.overdue .stat-icon {\n  background: linear-gradient(135deg, #e53e3e 0%, #c53030 100%);\n}\n\n.stat-card.amount .stat-icon {\n  background: linear-gradient(135deg, #9f7aea 0%, #805ad5 100%);\n}\n\n.stat-icon {\n  font-size: 2rem;\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  color: white;\n  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);\n}\n\n.stat-content h4 {\n  color: #4a5568;\n  font-size: 0.9rem;\n  font-weight: 600;\n  margin: 0 0 4px 0;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.stat-value {\n  color: #2d3748;\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin: 0;\n  line-height: 1.2;\n}\n\n/* Sync Section */\n.sync-section {\n  margin-bottom: 32px;\n}\n\n.sync-section h3 {\n  color: #2d3748;\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 0 0 16px 0;\n}\n\n.sync-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n}\n\n.sync-card {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 12px;\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  box-shadow:\n    0 4px 16px rgba(0, 0, 0, 0.1),\n    0 2px 8px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.sync-card:hover {\n  transform: translateY(-2px);\n  box-shadow:\n    0 8px 24px rgba(0, 0, 0, 0.15),\n    0 4px 12px rgba(0, 0, 0, 0.08);\n}\n\n.sync-card.failed .sync-icon {\n  background: linear-gradient(135deg, #e53e3e 0%, #c53030 100%);\n}\n\n.sync-card.pending .sync-icon {\n  background: linear-gradient(135deg, #d69e2e 0%, #b7791f 100%);\n}\n\n.sync-card.success-rate .sync-icon {\n  background: linear-gradient(135deg, #38a169 0%, #2f855a 100%);\n}\n\n.sync-icon {\n  font-size: 2rem;\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  color: white;\n  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);\n}\n\n.sync-content h4 {\n  color: #4a5568;\n  font-size: 0.9rem;\n  font-weight: 600;\n  margin: 0 0 4px 0;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.sync-value {\n  color: #2d3748;\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin: 0;\n  line-height: 1.2;\n}\n\n/* System Status Section */\n.system-status-section {\n  margin-bottom: 32px;\n}\n\n.system-status-section h3 {\n  color: #2d3748;\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 0 0 16px 0;\n}\n\n.status-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n}\n\n.status-card {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 12px;\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  box-shadow:\n    0 4px 16px rgba(0, 0, 0, 0.1),\n    0 2px 8px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.status-card:hover {\n  transform: translateY(-2px);\n  box-shadow:\n    0 8px 24px rgba(0, 0, 0, 0.15),\n    0 4px 12px rgba(0, 0, 0, 0.08);\n}\n\n.status-card.configured .status-icon,\n.status-card.connected .status-icon,\n.status-card.running .status-icon {\n  background: linear-gradient(135deg, #38a169 0%, #2f855a 100%);\n}\n\n.status-card.not-configured .status-icon,\n.status-card.disconnected .status-icon,\n.status-card.stopped .status-icon {\n  background: linear-gradient(135deg, #e53e3e 0%, #c53030 100%);\n}\n\n.status-icon {\n  font-size: 2rem;\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  color: white;\n  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);\n}\n\n.status-content h4 {\n  color: #4a5568;\n  font-size: 0.9rem;\n  font-weight: 600;\n  margin: 0 0 4px 0;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.status-content p {\n  color: #2d3748;\n  font-size: 1.2rem;\n  font-weight: 700;\n  margin: 0;\n  line-height: 1.2;\n}\n\n/* Recent Invoices Section */\n.recent-invoices-section {\n  margin-bottom: 32px;\n}\n\n.recent-invoices-section h3 {\n  color: #2d3748;\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 0 0 16px 0;\n}\n\n.invoices-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.invoice-item {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 8px;\n  padding: 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  box-shadow:\n    0 2px 8px rgba(0, 0, 0, 0.1),\n    0 1px 4px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.invoice-info {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.invoice-number {\n  background: rgba(13, 59, 102, 0.1);\n  color: #0D3B66;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.invoice-member {\n  color: #2d3748;\n  font-weight: 500;\n}\n\n.invoice-details {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.invoice-amount {\n  color: #2d3748;\n  font-weight: 600;\n  font-size: 1.1rem;\n}\n\n.invoice-status {\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.invoice-status.draft {\n  background: rgba(214, 158, 46, 0.1);\n  color: #d69e2e;\n}\n\n.invoice-status.sent {\n  background: rgba(49, 130, 206, 0.1);\n  color: #3182ce;\n}\n\n.invoice-status.paid {\n  background: rgba(56, 161, 105, 0.1);\n  color: #38a169;\n}\n\n.invoice-status.overdue {\n  background: rgba(229, 62, 62, 0.1);\n  color: #e53e3e;\n}\n\n/* Overdue Invoices Section */\n.overdue-invoices-section h3 {\n  color: #2d3748;\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 0 0 16px 0;\n}\n\n.overdue-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.overdue-item {\n  background: rgba(229, 62, 62, 0.05);\n  border: 1px solid rgba(229, 62, 62, 0.2);\n  border-radius: 8px;\n  padding: 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.overdue-info {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.overdue-number {\n  background: rgba(229, 62, 62, 0.1);\n  color: #e53e3e;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.overdue-member {\n  color: #2d3748;\n  font-weight: 500;\n}\n\n.overdue-days {\n  color: #e53e3e;\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n\n.overdue-amount {\n  color: #2d3748;\n  font-weight: 600;\n  font-size: 1.1rem;\n}\n\n/* Empty States */\n.no-invoices {\n  text-align: center;\n  padding: 40px;\n  color: #4a5568;\n}\n\n/* Loading and Error States */\n.loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n}\n\n.error-state {\n  text-align: center;\n  padding: 60px 20px;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 16px;\n  box-shadow:\n    0 8px 32px rgba(0, 0, 0, 0.1),\n    0 4px 16px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.error-state h3 {\n  color: #2d3748;\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 0 0 12px 0;\n}\n\n.error-state p {\n  color: #4a5568;\n  font-size: 1rem;\n  margin: 0 0 24px 0;\n  line-height: 1.5;\n}\n\n/* Buttons */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  border: none;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  text-decoration: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n}\n\n.btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);\n  color: white;\n}\n\n.btn-primary:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n.btn-outline {\n  background: transparent;\n  color: #0D3B66;\n  border: 1px solid #0D3B66;\n}\n\n.btn-outline:hover:not(:disabled) {\n  background: #0D3B66;\n  color: white;\n}\n\n.btn-sm {\n  padding: 6px 12px;\n  font-size: 0.8rem;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .enhanced-invoice-dashboard {\n    padding: 16px;\n  }\n\n  .enhanced-invoice-dashboard-header {\n    flex-direction: column;\n    gap: 16px;\n    text-align: center;\n  }\n\n  .header-actions {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .dashboard-tabs {\n    flex-direction: column;\n  }\n\n  .tab-button {\n    text-align: center;\n  }\n\n  .stats-grid,\n  .sync-cards,\n  .status-cards {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 12px;\n  }\n\n  .invoice-item {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  .invoice-details {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n\n@media (max-width: 480px) {\n  .enhanced-invoice-dashboard {\n    padding: 12px;\n  }\n\n  .enhanced-invoice-dashboard-header {\n    padding: 16px;\n  }\n\n  .header-content h2 {\n    font-size: 1.5rem;\n  }\n\n  .stats-grid,\n  .sync-cards,\n  .status-cards {\n    grid-template-columns: 1fr;\n  }\n\n  .stat-card,\n  .sync-card,\n  .status-card {\n    padding: 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
